import { SetupContext, ref } from '@vue/composition-api';
import { useLocalStorage } from 'vue-composable';

const { storage: storedDrawer } = useLocalStorage('_storiesonboard_isNavDrawerOpen', true);

export function useNavDrawer(ctx: SetupContext) {
    const drawer = ref(storedDrawer.value && ctx.root.$vuetify.breakpoint.mdAndUp);

    const toggleNavDrawer = (val: boolean | null = null, shouldSave: boolean) => {
        drawer.value = val ?? !drawer.value;

        if (shouldSave) {
            storedDrawer.value = drawer.value;
        }
    };

    return {
        drawer,
        toggleNavDrawer,
        storedDrawer,
    };
}
